var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateView',[_c('div',{staticClass:"container"},[_c('TemplatePageGrid',{attrs:{"items":_vm.workExtraTypeGrid,"page-data":_vm.pageData,"loading":_vm.loadingAnimation,"sort-az":"last_name"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [(
            _vm.$userCheckAccess({
              abilities: 'edit_work_extra_types',
            })
          )?_c('WorkExtraTypeModal',{attrs:{"create":true}}):_vm._e()]},proxy:true}])},[_c('WorkExtraTypeTable',{attrs:{"items":_vm.workExtraTypeGrid}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }